import React from 'react';
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../../components/LocalizedLink/LocalizedLink';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <section className="section-padding container-custom text-center min-h-[50vh]">
      <p className="text-orange-accent text-xl mb-4">404</p>
      <h1 className="text-3xl md:text-4xl font-bold mb-6">{t('seo.notFound.heading')}</h1>
      <p className="text-gray-600 mb-8">{t('seo.notFound.description')}</p>
      <LocalizedLink to="/" className="btn-primary">{t('seo.notFound.backHome')}</LocalizedLink>
    </section>
  );
}
